import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.css';
import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 60 * 1000; //轮询时间间隔

/**
 * * 学院女生比例Top5展示面板
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04 
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            cardData: [], //学院女生比例统计数据
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        clearTimeout(this.polling);
    }

    /**
     * * 获取学院女生比例统计数据
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/sstj/getCollegeWithHighestProportionOfGirls?num=10', 'GET'
        // ,{num:10}
        )
            .then(res => {
                if (res && res.data) {
                    this.setState({ errCount: 0, cardData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    /**
     * * 构造女生比例排名前五的学院数据
     * @memberof Home
     */
    getRateOfCollegeGirlsOption = (start = 0, end = 5) => {

        const { cardData = [] } = this.state;

        return cardData.slice(start, end).map((item, index) => {
            return (
                <div
                    className={styles.bottom_item}
                    key={item.pm}
                    style={{display:'flex'}}
                >
                    <span
                        className={classNames(
                            styles.px,
                            {
                                [styles.px_1]:
                                    item.pm == 1,
                                [styles.px_2]:
                                    item.pm == 2,
                                [styles.px_3]:
                                    item.pm == 3
                            }
                        )}
                    >
                        {item.pm}
                    </span>
                    <span className={styles.zy}>
                        {item.xymc}
                    </span>
                    <span
                        className={classNames(
                            styles.num,
                            {
                                [styles.px_1]:
                                    item.pm == 1,
                                [styles.px_2]:
                                    item.pm == 2
                            }
                        )}
                    >
                        {
                            (item.nvsbl == 0 || item.nvsbl == 1) ? `${item.nvsbl * 100}%` : `${parseFloat(item.nvsbl * 100).toFixed(2)}%`
                        }
                    </span>
                </div>
            );
        });
    }

    getRateOfCollegeGirlsOption2 = (start = 5, end = 10) => {

        const { cardData = [] } = this.state;

        return cardData.slice(start, end).map((item, index) => {
            return (
                <div
                    className={styles.bottom_item}
                    key={item.pm}
                    style={{display:'flex'}}
                >
                    <span
                        className={classNames(
                            styles.px,
                        )}
                    >
                        {item.pm}
                    </span>
                    <span className={styles.zy}>
                        {item.xymc}
                    </span>
                    <span
                        className={classNames(
                            styles.num,
                           
                        )}
                    >
                        {
                            (item.nvsbl == 0 || item.nvsbl == 1) ? `${item.nvsbl * 100}%` : `${parseFloat(item.nvsbl * 100).toFixed(2)}%`
                        }
                    </span>
                </div>
            );
        });
    }

    render() {
        return (
            <div style={{ display: 'flex', height: '80%' }}>
                <div className={styles.bottom_list}>
                    {this.getRateOfCollegeGirlsOption(0, 5)}
                </div>
                {/* <div className={styles.bottom_list} style={{ marginLeft: '2%' }} >
                    {this.getRateOfCollegeGirlsOption2(5, 10)}
                </div> */}
            </div>

        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-sszy/_CardBox3.js